import * as React from 'react';
const ThemeContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
export default ThemeContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/private-theming/useTheme/ThemeContext.js
// module id = 758
// module chunks = 22